// extracted by mini-css-extract-plugin
module.exports = {"vendorOrganizationWizard":"CompanyAssignmentWizard_vendorOrganizationWizard__X8mh9"};